import { createSlice } from "@reduxjs/toolkit";
import { apiCallBegan } from "../api";
import  BASE_URL  from "../../config/host";

export const highlightSlice = createSlice({
    name: 'highlights',
    loading: false,
    initialState: {
        highlightlist: [],
        highlightCount: 0
    },
    reducers:{
        listRequested: (state, action)=>{
            state.loading = true;
        },
        listRequestFailed: (state, action)=>{
            state.loading = false;
            state.highlightlist ='';
            //console.log(action.payload);
        },
        listReceived: (state, action)=>{
            state.loading = false;
            state.highlightlist = action.payload.data?action.payload.data:[];
            state.highlightCount = action.payload.count || 0
        }
    }
});


export const {listReceived,listRequested ,listRequestFailed } = highlightSlice.actions;
//console.log(body);
export const fetchHighlights = (body)=> apiCallBegan({
    url: '/our_highlight/list',
    method: 'post',
    data: body,
    baseUrl: BASE_URL,
    onSuccess: listReceived.type,
    onStart: listRequested.type,
    onError: listRequestFailed.type
 
});














